import { render, staticRenderFns } from "./UserEditCredentials.vue?vue&type=template&id=b79a0cfe&"
import script from "./UserEditCredentials.vue?vue&type=script&lang=js&"
export * from "./UserEditCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports